// web-v2/src/lib/arAnswer.js
//
// Browser copy of utils/ar-answer.js vocabulary (190 ADDENDUM §D): the six
// answers to "how was this bind actually paid" and the columns each needs.
// The server validates and maps; this only shapes the form. Pinned member
// for member to the server copy by tests/ar-financed.test.js.

export const ANSWERS = Object.freeze(['paid_outside_nickel', 'paid_short_absorbed', 'collected_elsewhere', 'deferred', 'financed', 'financed_acceleration', 'void', 'not_sure']);
export const METHODS = Object.freeze(['check', 'wire', 'ach']);
export const REQUIRED = Object.freeze({
  paid_outside_nickel:   ['amount', 'date', 'method', 'trust_account'],
  paid_short_absorbed:   ['amount', 'date', 'method', 'trust_account', 'shortfall', 'reason'],
  collected_elsewhere:   ['reason'],
  deferred:              ['reason'],
  financed:              ['finance_company', 'reference', 'date'],
  financed_acceleration: ['amount', 'date', 'reference', 'trust_account'],
  void:                  ['reason'],
  not_sure:              [],
});
export const ANSWER_LABELS = Object.freeze({
  paid_outside_nickel:   'Paid outside a TRACON Nickel link (check, wire, ACH)',
  paid_short_absorbed:   'Paid short, agency absorbed the difference',
  collected_elsewhere:   'Collected by someone else (co-broker, carrier direct)',
  deferred:              'Deferred (my decision, silent to the client)',
  financed:              'Financed (finance company paid the carrier)',
  financed_acceleration: 'Financed into trust (Acceleration paper)',
  void:                  'Void this bind (it never happened)',
});
// Every column the form may show; a field is shown when its answer requires
// or accepts it. Optional fields per answer, beyond REQUIRED:
export const OPTIONAL = Object.freeze({
  paid_outside_nickel:   ['reference'],
  paid_short_absorbed:   ['reference'],
  collected_elsewhere:   ['amount', 'date'],
  deferred:              ['date'],
  financed:              [],
  financed_acceleration: [],
  void:                  [],
  not_sure:              [],
});
